import { createFileRoute, useParams, useRouteContext } from "@tanstack/react-router";

import { EditProgramPage } from "./-components/edit-program.page";

export const Route = createFileRoute("/_authenticated/org/$orgId/program/$programId/edit/")({
  component: Page
});

function Page() {
  const { orgId, programId } = useParams({
    from: "/_authenticated/org/$orgId/program/$programId/edit/"
  });
  const { program } = useRouteContext({
    from: "/_authenticated/org/$orgId/program/$programId/edit/"
  });
  return <EditProgramPage orgId={orgId} programId={programId} program={program} />;
}
